export default (ngModule: ng.IModule) => {
  ngModule.directive('fretesFiltro', fretesFiltroDirective);
};

function fretesFiltroDirective(): ng.IDirective {
  return {
    restrict: 'E',
    template: require('./fretes-filtro.html'),
    scope: {
      limpar: '='
    },
    controller: FiltroController,
    controllerAs: 'vm',
    bindToController: true
  };
}

/** @ngInject */
function FiltroController($mdSidenav, $mdMedia, $state, $window, Cidades, Fretes, ScrollControl) {
  let vm = this;

  vm.$mdMedia = $mdMedia;
  vm.close = () => $mdSidenav('left').close();
  vm.toggle = () => $mdSidenav('left').toggle();
  vm.voltar = () => $window.history.back();
  vm.mostrarBtnVoltar = () => {
    return $state.is('consulta.fretes.detalhe') || !$state.is('consulta.fretes.listagem', {index: 0});
  };
  vm.titulo = () => $state.is('consulta.fretes.detalhe') ? 'Detalhes do Frete' : 'Fretes';

  vm.Fretes = Fretes;
  vm.buscarCidades = Cidades.buscarCidades;
  vm.limpar = limpar;
  vm.buscarFretes = buscarFretes;

  function limpar() {
    vm.searchOrigem = '';
    vm.searchDestino = '';
    Fretes.limparFiltro();
  }

  function buscarFretes() {
    Fretes.limparCache();
    ScrollControl.reset();
    $state.go('consulta.fretes.listagem', {index: 0}, {reload: true});
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/fretes/fretes-filtro.directive.ts
 **/